import React from 'react'
// libs
import styled, { css } from 'styled-components'
import { transparentize } from 'polished'
// components
import FormControl from '@mui/material/FormControl'
// themes
import { colors } from 'themes'
// constants
import { WYSIWIG_CLASS_NAMES } from 'constants/wysiwig'

export const FormControlWrapper = styled(({ focused, ...props }) => <FormControl {...props} />)`
  && {
    position: relative;
  }

  label {
    top: -3px;
  }

  .${WYSIWIG_CLASS_NAMES.wrapperClassName} {
    border: 1px solid ${transparentize(0.77, colors.black)};
    border-radius: 3px;

    &:hover {
      outline: 1px solid ${colors.black};
      border-color: ${colors.black};
    }

    ${({ focused }) =>
      focused &&
      css`
        border-width: 2px;
        border-color: ${colors.purple450} !important;
      `};

    display: flex;
    flex-direction: column-reverse;
    margin-top: 14px;
  }

  .${WYSIWIG_CLASS_NAMES.editorClassName} {
    padding: 0 14px 14px 14px;

    img {
      width: 100%;
    }
  }

  .${WYSIWIG_CLASS_NAMES.toolbarClassName} {
    border: none;
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 4px;
  }

  .${WYSIWIG_CLASS_NAMES.blockTypeClassName} {
    overflow-y: unset;
    position: fixed;
    width: 110px;
  }

  .${WYSIWIG_CLASS_NAMES.fontSizeClassName} {
    max-height: unset;
    overflow-y: unset;
    position: fixed;
    width: 40px;
  }

  .${WYSIWIG_CLASS_NAMES.fontFamilyClassName} {
    overflow-y: unset;
    position: fixed;
    width: 115px;
  }
`
